<div class="flex flex-auto">
    <p-autoComplete appendTo="body" [suggestions]="modifierSuggestions"  [(ngModel)]="modifiers" multiple
                        (completeMethod)="modifierSearch($event)" placeholder="Search Modifiers" optionLabel="code"
                        class="m-2 flex flex-auto" styleClass="flex flex-auto" inputStyleClass="flex flex-auto" (onSelect)="selectModifier($event)" (onUnselect)="selectModifier($event)">
        <ng-template let-modifier pTemplate="item">
            <div class="flex align-items-center gap-2" >
                <div class="flex" >{{ modifier.code }} - {{modifier.description | slice : 0 : 100}}<span *ngIf="modifier.description.length > 100">...</span></div>
            </div>
        </ng-template>
    </p-autoComplete>
</div>